export default __webpack_public_path__ + "img/slogan.697cd1c3.svg";